import { createNames } from "../../utils";
export const getAceButtonNames = (id) => {
    const { ID, CLASS } = createNames(id, 'ACE-BUTTON', 'CIRCULAR', 'DISABLED', 'DISABLE_ANIMATIONS', 'FULL_HEIGHT', 'FULL_WIDTH', 'FULL_WIDTH_MOBILE', 'FULL_WIDTH_TABLET', 'HIGHLIGHT', 'SIZE_LARGE', 'SIZE_MEDIUM', 'SIZE_SMALL', 'SIZE_EXTRA_SMALL', 'TYPE_PRIMARY', 'TYPE_SECONDARY', 'TYPE_SECONDARY_DARK', 'TYPE_TERTIARY', 'TYPE_TERTIARY_DARK', 'TYPE_HIDDEN', 'TYPE_HIDDEN_INVERTED', 'TYPE_HIDDEN_DARK', 'CONTENT__WRAPPER', 'CONTENT__WRAPPER____LOADING', 'CONTENT', '_HIGHLIGHT_BACKGROUND', '_HIGHLIGHT_ANIMATION_DELAY', '_HIGHLIGHT_ANIMATION_DURATION', '_HIGHLIGHT_ANIMATION_ITERATION_COUNT');
    return {
        ID,
        PART: {
            ROOT: CLASS.ROOT,
        },
        CLASS: Object.assign(Object.assign({}, CLASS), { TYPE_DISABLED: (type) => `button--${type}--disabled` })
    };
};
export const aceButtonCssVariables = {
    HIGHLIGHT_BACKGROUND: '--ace-button-highlight-background',
    HIGHLIGHT_ANIMATION_DELAY: '--ace-button-highlight-animation-delay',
    HIGHLIGHT_ANIMATION_DURATION: '--ace-button-highlight-animation-duration',
    HIGHLIGHT_ANIMATION_ITERATION_COUNT: '--ace-button-highlight-animation-iteration-count',
};
//# sourceMappingURL=ace-button.get-names.js.map
